import { cartConstants } from "../constants";

const start = () => {
    return {type: cartConstants.CART_PROCESS_START, payload: {loading: true}};
};

const stop = () => {
    return {type: cartConstants.CART_PROCESS_STOP, payload: {loading: false}};
};

const list = (res) => {
    return {type: cartConstants.CART_LIST, payload: {list: res}};
};

const add = (res) => {
    return {type: cartConstants.CART_ADD, payload: {add: res}};
};

const update = (res) => {
    return {type: cartConstants.CART_UPDATE, payload: {update: res}};
};

const remove = (res) => {
    return {type: cartConstants.CART_REMOVE, payload: {remove: res}};
};

const removeAll = (res) => {
    return {type: cartConstants.CART_REMOVE_All, payload: {removeAll: res}};
};

const clear = (res) => {
    return {type: cartConstants.CART_CLEAR, payload: {clear: res}};
};

export const cartSelectors = {
    start,
    stop,
    list,
    add,
    update,
    remove,
    removeAll,
    clear
}